<template>
    <b-navbar type="light" toggleable="lg" class="navbar-custom fixed-top"
        :class="{'spacingReset': currentRouteName === 'About'}">
        <b-navbar-brand to="/" class="navbar-brand-background">
            <span>
                <img src="../../assets/logo-cropped.png" class="navbar-brand navbar-logo-arrange">
            </span>
        </b-navbar-brand>
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav class="mynav navbar-nav ml-auto pt-2 pt-lg-0">
                <b-nav-form class="navbar-form position-relative d-inline-block d-lg-inline-flex">
                    <input class="search-input pl-2 text-normal" />
                    <button class="btn btn-sm submit-btn" type="submit">
                        <img src="../../assets/search.svg">
                    </button>
                </b-nav-form>
                <b-nav-item class="mx-2 nav-item-text text-black" to="/">
                    <img src="../../assets/private-house-normal.svg" 
                    v-if="currentRouteName === 'Home'"
                    class="home-icon">
                    <img src="../../assets/private-house.svg" 
                    v-if="currentRouteName !== 'Home'"
                    class="home-icon">                
                    <hr :class="{'displayed': currentRouteName === 'Home'}" />
                </b-nav-item>
                <b-nav-item class="mx-3 nav-item-text text-black"
                    :active="currentRouteName === 'OurHouses' ||
                    currentRouteName === 'OurHousesDetails' ||
                    currentRouteName === 'Estates'"
                    to="/projects">Projects
                    <hr :class="{'displayed': currentRouteName === 'Projects' ||
                        currentRouteName === 'OurHouses' ||
                        currentRouteName === 'OurHousesDetails' ||
                        currentRouteName === 'Estates'}" />
                    </b-nav-item>
                <b-nav-item class="mx-3 nav-item-text text-black"
                    :active="currentRouteName === 'ExecDetails'"
                    to="/about-us">About Us
                    <hr :class="{'displayed': currentRouteName === 'About' || currentRouteName === 'ExecDetails'}" />
                    </b-nav-item>
                <b-nav-item class="mx-3 nav-item-text text-black"
                    to="/contact-us">Contact Us
                    <hr :class="{'displayed': currentRouteName === 'Contact'}" />
                    </b-nav-item>
                <b-nav-item class="mx-3 nav-item-text text-black"
                    to="/testimonials">Testimonials
                    <hr :class="{'displayed': currentRouteName === 'Testimonials'}" />
                    </b-nav-item>
                <b-nav-item class="mx-3 nav-item-text text-black"
                    to="/an-agent">An Agent
                    <hr :class="{'displayed': currentRouteName === 'BecomeAnAgent'}" />
                    </b-nav-item>
            </b-navbar-nav>
            <!-- <div class="social-icon my-lg-0">
                <SocialLinks />
            </div> -->
        </b-collapse>
    </b-navbar>    
</template>

<script>
export default {
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },
    data() {
        return {
        }
    }
}
</script>

<style>
.navbar-nav {
    background-color: #ece5ec;
    color: #000;
    border-radius: 25px;
    padding-left: 20px !important;
    font-size: 11px;
    font-weight: 500;
}
.nav-link {
    color: #222!important;
}
.nav-link hr {
    border-top: 1px solid #6E2169;
    width: 80%;
    margin: 0 auto;
    position: relative;
    top: 7px;
    display: none;
}
@media (max-width: 992px) {
    .nav-link hr {
        width: 35px
    }
}
@media (min-width: 992px) {
    .navbar {
        padding: 0 1rem!important
    }
}
.nav-item-text {
    position: relative;
    padding-top: .32rem;
}
.navbar-form {
    position: relative;
}
.home-icon {
    width: 17px;
}
.router-link-active, .active {
    color: #6E2169 !important;
}
.router-link-active hr.displayed,
.active hr.displayed {
    display: block
}
.search-input {
    border: 1px solid #6E2169;
    border-radius: 10px;
    width: 100%;
    padding: 0 4px;
    margin-right: 30px;
    background-color: #ece5ec;
}
@media (max-width: 992px) {
    .search-input {
        min-width: 180px;
    }
}
@media (min-width: 768px) {
    .navbar-custom {
        padding: 0 20px !important;
    }
}
@media (min-width: 992px) {
    .navbar-custom {
        padding: 0 70px !important;
    }
    .navbar-custom.spacingReset {
        padding: 0 50px !important;
    }
}
.submit-btn {
    position: absolute;
    right: 30px;
    background: transparent;
    font-size: 10px;
}
.submit-btn img {
    width: 13px;
    position: relative;
    bottom: 1px;
}
</style>